import http from "../utils/http";

export const getRankings = async (): Promise<Response> => {
  return await http.get(`/api/rankings`);
};
